
import Vue from "vue";
import Employee from "@/interface/Employee";
import { EmployeesApi } from "@/api";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import EmployeeCard from "@/components/EmployeeCard.vue";
import EmployeeCount from "@/components/EmployeeCount.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";

declare interface ComponentData {
  loading: boolean;
  employees: Employee[];
  error: Error;
}

export default Vue.extend({
  name: "HomeView",
  data(): ComponentData {
    return {
      loading: true,
      employees: [] as Employee[],
      error: {} as Error,
    };
  },
  methods: {
    // Get all employees
    async retrieveEmployees(): Promise<void> {
      EmployeesApi.getAll()
        .then((employees) => {
          this.employees = employees;
        })
        .catch((error: Error) => {
          this.error = error;
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    // Is everything ready to display
    showElements(): boolean {
      return !!this.employees.length && !this.isError;
    },
    // Are Errors available
    isError(): boolean {
      return !!Object.keys(this.error).length;
    },
  },
  mounted() {
    this.retrieveEmployees();
  },
  components: { ErrorMessage, EmployeeCount, EmployeeCard, LoadingIndicator },
});
